import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getActiveTickets, getTemplateGroups, getMode, getCameraMode } from '../../api/axios';
import Table from '../Table/Table';
import { useTranslation } from 'react-i18next';

const ActiveTickets = () => {
  const { t } = useTranslation('global');
  const [loading, setLoading] = useState(true);
  const [activeTickets, setActiveTickets] = useState([]);
  const [templateGroups, setTemplateGroups] = useState([]);
  const [mode, setMode] = useState("0");
  const [cameraMode, setCameraMode] = useState("0");

  const location = useLocation();
  const { startDate, endDate } = location.state || {};

  const formatDateTime = (change_time, daysOffset, time) => {
    const date = new Date(change_time);
    date.setDate(date.getDate() + daysOffset);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day} ${time}`;
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const mode = await getMode();
        const cameraMode = await getCameraMode();
        const groups = await getTemplateGroups();
        const res = await getActiveTickets(startDate, endDate);

        setMode(mode);
        setCameraMode(cameraMode);

        const formatted = res.map(ticket => ({
          ...ticket,
          h_from: formatDateTime(ticket.change_time, 0, ticket.h_from),
          h_to: formatDateTime(ticket.change_time, ticket.day_no - 1, ticket.h_to),
        }));

        setActiveTickets(formatted);
        setTemplateGroups(groups);
      } catch {
        setActiveTickets([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [startDate, endDate]);

  // 🔥 Ovo otvara novi tab sa URL-om kojeg backend obradi
  const handleOpenResend = (ticket) => {
    const url = `/resend-mail?id=${ticket.ticket_id}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const columns = [
    { heading: t('reports.ticket'), value: 'ticket_id' },
    { heading: t('reports.reader'), value: 'reader_group' },
    { heading: t('reports.name'), value: 'name' },
    { heading: t('reports.surname'), value: 'surname' },
    { heading: t('reports.phone'), value: 'phone' },
    { heading: t('reports.dateCreated'), value: 'create_time' },
    { heading: t('reports.from'), value: 'h_from' },
    { heading: t('reports.until'), value: 'h_to' },
    { heading: t('reports.numberOfDays'), value: 'day_no' },
    { heading: t('reports.entryNumber'), value: 'entry_no' },
    { heading: t('reports.dailyNumberOfEntries'), value: 'daily_no' },
    { heading: t('reports.email'), value: 'email' },

    // 🔥 Ovde dodajemo dugme koje poziva handleOpenResend
    {
      heading: 'PDF',
      value: '_pdfAction',
      render: (ticket) => (
        <button
          style={{ padding: "5px 12px", cursor: "pointer" }}
          onClick={() => handleOpenResend(ticket)}
        >
          Open
        </button>
      )
    }
  ];

  return (
    <>
      <h2>{t('reports.activeTickets')}</h2>

      {loading ? (
        <p>{t('reports.loading')}</p>
      ) : (
        <Table
          data={activeTickets}
          column={columns}
          onPdfClick={handleOpenResend}
        />
      )}
    </>
  );
};

export default ActiveTickets;
